import React from 'react'

import Flex from '~shared/ui/Flex'
import Text from '~shared/ui/Text'

interface ActionControlProps extends React.HTMLAttributes<HTMLElement> {
  action: React.ReactElement
  label: React.ReactNode
  disabled?: boolean
}

function ActionControl({ action, label, disabled, className }: ActionControlProps) {
  return (
    <Flex align="center" justify="space-between" gap="2" className={className}>
      <Text as="label" variant="secondary" textType="body-sm">
        {label}
      </Text>

      {React.isValidElement(action) &&
        React.cloneElement<Record<string, any>>(action, {
          ...(disabled !== undefined && { disabled: disabled === true }),
        })}
    </Flex>
  )
}

export default ActionControl
